const SOURCES = [
  {
    id: 1,
    authors: 'Office for Civil Rights, HHS',
    title: 'Summary of the HIPAA Privacy Rule',
    year: 2003,
    url: 'https://www.hhs.gov/hipaa/for-professionals/privacy/laws-regulations/index.html',
  },
  {
    id: 4,
    authors: 'Sweeney L',
    title: 'k-anonymity: A model for protecting privacy',
    year: 2002,
    url: 'https://epic.org/privacy/reidentification/Sweeney_Article.pdf',
  },
  {
    id: 7,
    authors: 'Sweeney L',
    title: 'Simple Demographics Often Identify People Uniquely',
    year: 2000,
    url: 'https://dataprivacylab.org/projects/identifiability/paper1.pdf',
  },
  {
    id: 8,
    authors: 'Dwork C, Roth A',
    title: 'The Algorithmic Foundations of Differential Privacy',
    year: 2014,
    url: 'https://www.cis.upenn.edu/~aaroth/Papers/privacybook.pdf',
  },
  {
    id: 9,
    authors: 'Kaissis G et al.',
    title: 'Secure, privacy-preserving and federated machine learning in medical imaging',
    year: 2020,
    url: 'https://www.nature.com/articles/s42256-020-0186-1',
  },
  {
    id: 10,
    authors: 'Office for Civil Rights, HHS',
    title: 'Guidance Regarding Methods for De-identification of Protected Health Information in Accordance with the HIPAA Privacy Rule',
    year: 2012,
    url: 'https://www.hhs.gov/hipaa/for-professionals/privacy/special-topics/de-identification/index.html',
  },
  {
    id: 11,
    authors: 'Office for Human Research Protections, HHS',
    title: 'Federal Policy for the Protection of Human Subjects (45 CFR Part 46)',
    year: 2018,
    url: 'https://www.hhs.gov/ohrp/regulations-and-policy/regulations/45-cfr-46/index.html',
  },
  {
    id: 12,
    authors: 'Walonoski J et al.',
    title: 'Synthea: An approach, method, and software mechanism for generating realistic synthetic patient data',
    year: 2018,
    url: 'https://academic.oup.com/jamia/article/25/3/230/4375190',
  },
  {
    id: 13,
    authors: 'Seastedt KP, Celi LA, et al.',
    title: 'Global healthcare fairness: We should be sharing more, not less, data',
    year: 2022,
    url: 'https://journals.plos.org/digitalhealth/article?id=10.1371/journal.pdig.0000102',
  },
  {
    id: 14,
    authors: 'Ross C, Molteni A',
    title: "Mayo Clinic's AI ambitions depend on patient data. Consent may be murky.",
    year: 2020,
    url: 'https://www.statnews.com/2020/06/03/mayo-clinic-patient-data-fuels-artificial-intelligence-consent-concerns/',
  },
  {
    id: 15,
    authors: 'Nemesure MD, Heinz MV, Huang R, Jacobson NC',
    title: 'Predictive modeling of depression and anxiety using electronic health records and a novel machine learning approach with artificial intelligence',
    year: 2021,
    url: 'https://doi.org/10.1038/s41598-021-81368-4',
  },
  {
    id: 16,
    authors: 'Ridgway J, Roth J',
    title: 'Data Brokers and the Sale of Americans\' Mental Health Data',
    year: 2023,
    url: 'https://techpolicy.sanford.duke.edu/data-brokers-and-the-sale-of-americans-mental-health-data/',
  },
  {
    id: 18,
    authors: 'U.S. Food and Drug Administration',
    title: 'Using Artificial Intelligence and Machine Learning in the Development of Drug and Biological Products',
    year: 2022,
    url: 'https://www.fda.gov/media/167973/download',
  },
  {
    id: 19,
    authors: 'Hutchinson N, Carlisle B, Doussau A, et al.',
    title: 'Patient Participation in Clinical Trials of Oncology Drugs and Biologics Preceding Approval by the US Food and Drug Administration',
    year: 2021,
    url: 'https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2779935',
  },
];

export default SOURCES;
